import HttpService from 'domovio-core/src/system/rest/rest.service';

export async function loadOrientations() {
    return HttpService.get('/v1/orientations');
}
